import React from 'react';
import {formatPrice} from '../../../utils/react';

interface Props {
    /** Line value before the offer-level discount (gross). */
    original: number;
    /** Line value after the offer-level discount is applied (net). */
    discounted: number;
    /** Currency label shown after the amounts. Defaults to the euro sign. */
    currency?: string;
    /** Tighter sizing for dense rows (e.g. sub-product table). */
    compact?: boolean;
}

/**
 * Compact "was → now" presentation of an offer-level discount on a single line
 * (product / sub-product / service): the gross price struck through, with the
 * net selling price beneath it. Space-efficient for narrow table cells. The
 * exact saved amount + percentage live in the (numbers-only, locale-safe) tooltip.
 */
const DiscountedPrice: React.FC<Props> = ({original, discounted, currency = '€', compact = false}) => {
    const saved = Math.max(0, original - discounted);
    const pct = original > 0 ? (saved / original) * 100 : 0;
    const title = `− ${formatPrice(saved)} ${currency} (${pct.toFixed(1)}%)`;

    return (
        <span className={`disc-chip${compact ? ' disc-chip--compact' : ''}`} title={title}>
            <span className="disc-chip__was">{formatPrice(original)} {currency}</span>
            <span className="disc-chip__now">{formatPrice(discounted)} {currency}</span>
        </span>
    );
};

export default DiscountedPrice;
